import './devMock';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './media_max480.css';
import './media_max992.css';
import 'react-datepicker/dist/react-datepicker.css';
import App from './App';
import FinviseFeeRules from './pages/FinviseFeeRules';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {process.env.REACT_APP_MOCK && window.location.pathname === '/__fees' ? <FinviseFeeRules orgId={1} /> : <App />}
    </React.StrictMode>
);
